import { useLayoutEffect } from 'react';

import { ReelContainer } from './components/reelContainer';
import { gameModuleStore } from './store/gameModuleStore';
import { ReSpinText } from './components/reSpinText';
import { GameBoard } from './components/gameBoard';
import { WildFireScene } from './components/wildFireScene';
import { isMobile } from '../helpers/isMobile';

export function GameModule(props) {
  const { getPropsFromFrame } = gameModuleStore;
  useLayoutEffect(() => {
    getPropsFromFrame({ ...props });
  }, []);

  return (
    <>
      {isMobile() && <WildFireScene />}
      <GameBoard />
      <ReelContainer />
      <ReSpinText />
    </>
  );
}
